import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { motion } from "framer-motion";
import { Bot, ArrowLeft, LayoutDashboard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/I18nContext";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useI18n();

  useEffect(() => {
    console.error("404: Route not found:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[500px] h-[300px] rounded-full bg-primary/8 blur-[100px]" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center space-y-6 relative z-10 px-4"
      >
        <div className="h-16 w-16 rounded-2xl bg-primary/10 border border-primary/20 flex items-center justify-center mx-auto">
          <Bot className="h-8 w-8 text-primary" />
        </div>

        <div className="space-y-2">
          <p className="text-xs font-medium text-primary uppercase tracking-widest">{t("notFound.kicker")}</p>
          <h1 className="text-6xl font-extrabold text-foreground">404</h1>
          <p className="text-muted-foreground max-w-sm mx-auto">
            {t("notFound.body")}
          </p>
        </div>

        <div className="flex items-center justify-center gap-3">
          <Button variant="outline" onClick={() => navigate(-1)} className="gap-2">
            <ArrowLeft className="h-4 w-4" /> {t("notFound.goBack")}
          </Button>
          <Button onClick={() => navigate("/dashboard")} className="gap-2">
            <LayoutDashboard className="h-4 w-4" /> {t("notFound.dashboard")}
          </Button>
        </div>

        <p className="text-[11px] text-muted-foreground/50 font-mono">{location.pathname}</p>
      </motion.div>
    </div>
  );
};

export default NotFound;
